import { useEffect, useState } from 'react';

const WA_LINK = 'https://wa.me/5541992570505?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20um%20especialista%20da%20KPR%20Advogados.';

export default function Hero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section
      id="inicio"
      className="relative w-full flex items-center overflow-hidden"
      style={{ minHeight: '80vh' }}
    >
      {/* Solid institutional green background */}
      <div className="absolute inset-0" style={{ background: '#0F3B2E' }} />

      {/* Subtle gold texture overlay */}
      <div
        className="absolute inset-0 opacity-[0.025] pointer-events-none"
        style={{ backgroundImage: 'repeating-linear-gradient(45deg, #C9A96E 0, #C9A96E 1px, transparent 0, transparent 50%)', backgroundSize: '20px 20px' }}
      />

      {/* Gold bottom line */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-kpr-gold/60 via-kpr-gold/30 to-transparent" />

      {/* Content – two-column layout */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

          {/* Left column – text */}
          <div className="flex-1 max-w-2xl">
            {/* Eyebrow */}
            <div
              className={`flex items-center gap-4 mb-8 transition-all duration-800 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ transitionDuration: '800ms' }}
            >
              <div className="w-12 h-px bg-kpr-gold" />
              <span className="text-kpr-gold text-xs font-medium tracking-[0.3em] uppercase">
                Advocacia Estratégica &amp; Empresarial
              </span>
            </div>

            {/* H1 */}
            <h1
              className={`font-serif text-5xl md:text-6xl lg:text-7xl text-white font-light leading-[1.08] mb-8 transition-all duration-700 delay-150 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              Soluções jurídicas
              <br />
              estratégicas para{' '}
              <span className="italic text-kpr-gold-light font-normal">empresas</span>
              <br />
              <span className="italic text-kpr-gold-light font-normal">e investidores.</span>
            </h1>

            {/* Divider */}
            <div
              className={`w-16 h-px bg-kpr-gold mb-8 transition-all duration-700 delay-300 ${visible ? 'opacity-100' : 'opacity-0'}`}
            />

            {/* Subtitle */}
            <p
              className={`text-white/60 text-base md:text-lg max-w-xl leading-relaxed mb-12 font-light transition-all duration-700 delay-300 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              Atuação especializada em direito empresarial, reestruturação e investimentos
              com segurança jurídica e visão estratégica para o seu crescimento.
            </p>

            {/* CTAs */}
            <div
              className={`flex flex-col sm:flex-row items-start gap-4 transition-all duration-700 delay-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-center gap-2.5 bg-kpr-gold hover:bg-kpr-gold-light text-kpr-dark font-semibold text-xs tracking-widest uppercase px-10 py-4 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-base w-4 h-4 flex items-center justify-center" />
                Falar com um especialista
              </a>
              <a
                href="#servicos"
                className="flex items-center gap-2.5 border border-white/25 hover:border-kpr-gold text-white/70 hover:text-kpr-gold text-xs tracking-widest uppercase px-10 py-4 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Conheça nossos serviços
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
            </div>

            {/* Stats row */}
            <div
              className={`mt-16 flex flex-col sm:flex-row gap-10 sm:gap-16 transition-all duration-700 delay-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
            >
              {[
                { value: '+15', label: 'Anos de experiência' },
                { value: 'Nacional', label: 'Atuação estratégica' },
                { value: 'PR & SC', label: 'Foco regional' },
              ].map((stat, i) => (
                <div key={stat.label} className="flex items-start gap-4">
                  {i > 0 && <div className="hidden sm:block w-px h-10 bg-white/15 self-center" />}
                  <div>
                    <div className="font-serif text-kpr-gold text-2xl font-light tracking-wide">{stat.value}</div>
                    <div className="text-white/40 text-xs tracking-wider uppercase mt-1">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right column – team photo */}
          <div
            className={`hidden lg:flex flex-shrink-0 w-[420px] xl:w-[480px] transition-all duration-1000 delay-300 ${visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'}`}
          >
            <div className="relative w-full" style={{ height: '560px' }}>
              {/* Gold accent border */}
              <div className="absolute -top-3 -right-3 w-full h-full border border-kpr-gold/30" />
              {/* Photo */}
              <img
                src="https://storage.readdy-site.link/project_files/e8b4defa-f953-4dea-a495-457cf6d0c478/c8e71fbb-7794-423d-821e-1c7fbc2d9f70_IMG_5966.JPG.jpeg?v=5984c36d921da9cf5cd25fe64a054422"
                alt="Equipe KPR Advogados"
                className="w-full h-full object-cover object-top"
              />
              {/* Subtle gradient overlay at bottom */}
              <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-kpr-dark/60 to-transparent" />
              {/* Caption */}
              <div className="absolute bottom-5 left-5">
                <span className="text-white/70 text-xs tracking-[0.2em] uppercase font-light">Nossa Equipe</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8 flex-col items-center gap-2 hidden md:flex">
        <div className="w-px h-10 bg-gradient-to-b from-transparent to-kpr-gold/50 animate-pulse" />
        <span className="text-white/30 text-[10px] tracking-[0.3em] uppercase" style={{ writingMode: 'vertical-rl' }}>Scroll</span>
      </div>
    </section>
  );
}
